import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { LeadForm } from "./LeadForm";

export const Contact = () => (
  <section id="consultation" data-testid="contact-section" className="grain relative bg-wealth-dark py-28 md:py-36 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(103,37,244,0.12),transparent_50%)]" />
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow index="06" label="Begin today" dark />
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-bone mt-5">
            The best day to start was yesterday. <span className="italic text-brand-light">The next best is today.</span>
          </h2>
          <p className="mt-7 text-base md:text-lg leading-relaxed text-bone/65 max-w-lg">
            Book a free 30-minute consultation. We will review where you stand,
            where you want to be, and the shortest honest route between the two.
          </p>

          <div className="mt-12 space-y-5">
            <a
              data-testid="contact-call-button"
              href="tel:+919730527427"
              className="group flex items-center gap-5 border border-bone/15 rounded-sm p-5 transition-[border-color,background-color] duration-400 hover:border-brand/60 hover:bg-white/5"
            >
              <span className="p-3 rounded-full bg-brand/20 text-brand-light"><Phone size={20} /></span>
              <span>
                <span className="block text-[10px] font-bold uppercase tracking-[0.24em] text-bone/45">Call now</span>
                <span className="block font-display text-2xl text-bone mt-0.5 group-hover:text-brand-light transition-colors duration-300">+91 97305 27427</span>
              </span>
            </a>
            <a
              data-testid="contact-whatsapp-button"
              href="https://wa.me/919730527427?text=Hi%20Madhura%2C%20I%20would%20like%20a%20free%20consultation."
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-5 border border-bone/15 rounded-sm p-5 transition-[border-color,background-color] duration-400 hover:border-brand/60 hover:bg-white/5"
            >
              <span className="p-3 rounded-full bg-brand/20 text-brand-light"><MessageCircle size={20} /></span>
              <span>
                <span className="block text-[10px] font-bold uppercase tracking-[0.24em] text-bone/45">WhatsApp</span>
                <span className="block font-display text-2xl text-bone mt-0.5 group-hover:text-brand-light transition-colors duration-300">Chat instantly</span>
              </span>
            </a>
            <a
              data-testid="contact-email-button"
              href="mailto:wealthymadhura@gmail.com"
              className="group flex items-center gap-5 border border-bone/15 rounded-sm p-5 transition-[border-color,background-color] duration-400 hover:border-brand/60 hover:bg-white/5"
            >
              <span className="p-3 rounded-full bg-brand/20 text-brand-light"><Mail size={20} /></span>
              <span>
                <span className="block text-[10px] font-bold uppercase tracking-[0.24em] text-bone/45">Email</span>
                <span className="block font-display text-2xl text-bone mt-0.5 group-hover:text-brand-light transition-colors duration-300">wealthymadhura@gmail.com</span>
              </span>
            </a>
            <div className="flex items-center gap-5 p-5">
              <span className="p-3 rounded-full bg-brand/20 text-brand-light"><MapPin size={20} /></span>
              <span>
                <span className="block text-[10px] font-bold uppercase tracking-[0.24em] text-bone/45">Based in</span>
                <span className="block font-display text-2xl text-bone mt-0.5">Pune — serving clients across India and Abroad</span>
              </span>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.15}>
          <div className="bg-white/[0.06] backdrop-blur-2xl border border-white/15 rounded-sm p-8 md:p-12 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.6)]">
            <h3 className="font-display text-3xl font-medium text-bone tracking-tight">Request a callback</h3>
            <p className="text-sm text-bone/55 mt-2 mb-9">Free consultation — typically confirmed within a few hours.</p>
            <LeadForm source="contact" dark />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
